import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { detailsSelector } from '../../../../../../redux/product/product.details.selectors';
import { detailsDispatcher } from '../../../../../../redux/product/product.dispatchers';
import { styles, DetailsComponent } from './details';
export const Details = connect(detailsSelector, detailsDispatcher)(withStyles(styles)(DetailsComponent));